import React from "react";
import { useOutletContext } from "react-router-dom";
import ImageInput from "../../../components/WriteProject/ImageInput/ImageInput";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { ProjectType } from "../../../interface/interface";

function Step2() {
  const {
    state: {
      leader: { img, title, intro, link },
    },
    isError,
    UpdateCommon,
  }: {
    state: ProjectType;
    isError: boolean;
    UpdateCommon: (type: string, payload: string | number) => void;
  } = useOutletContext();

  return (
    <div className="step2">
      <WpTitle title="팀플리더 소개" />
      <div className="step2-wrapper">
        <div className="left">
          <div className="title-wrapper">
            <div className="title">
              타이틀
              <span>개행 가능</span>
            </div>
            <textarea
              placeholder="타이틀을 입력해주세요"
              defaultValue={title}
              onBlur={(e) => {
                UpdateCommon("leader/title", e.target.value);
              }}
            ></textarea>
          </div>
          <div className="content-wrapper">
            <div className="title">소개글</div>
            <textarea
              placeholder="소개글을 입력해주세요"
              defaultValue={intro}
              onBlur={(e) => {
                UpdateCommon("leader/intro", e.target.value);
              }}
            ></textarea>
          </div>
          <div className="link-wrapper">
            <div className="title">포트폴리오 링크</div>
            <div className="input-wrapper">
              <img src="/assets/common/link.svg" alt="" />
              <input
                type="text"
                defaultValue={link}
                placeholder="링크를 입력해주세요"
                onBlur={(e) => {
                  UpdateCommon("leader/link", e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="right">
          <ImageInput
            data={img}
            title="팀플리더 이미지"
            sub="jpg / png 확장자 / 727x470px 권장"
            __update={UpdateCommon}
            isError={isError}
            type="leader/img"
          />
        </div>
      </div>
    </div>
  );
}

export default Step2;
